import { render } from "./lyInputRange.vue?vue&type=template&id=04052096"
import script from "./lyInputRange.vue?vue&type=script&lang=js"
export * from "./lyInputRange.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__